import {SEARCH_COUNT_PAYLOAD} from '../Types/types'


export interface initialState {
  data: null
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state: initialState = {data: null}, action: any) {
  switch (action.type) {
    case SEARCH_COUNT_PAYLOAD:
      return {
        ...state,
        data: action.payload
      }
    default:
      return state
  }
}